import type { TagId, TagConfig } from 'src/types/types';
import { TagItem } from 'src/components/TagItem/TagItem';

import styles from './styles.module.scss';

type TagsProps = {
  tags: TagId[];
  config: Record<TagId, TagConfig>;
};

export const TagList = ({ tags, config }: TagsProps) => {
  if (!tags.length) return null;

  return (
    <ul className={styles.tags}>
      {tags.map((t) => (
        <TagItem key={t} tag={t} config={config} />
      ))}
    </ul>
  );
};
